<template>
  <div class="search--room" v-if="room" :class="{
    selected: selected === room.id,
    'not-selected': selected !== null && selected !== room.id
  }"
       @mouseenter="setHovered(true)" @mouseleave="setHovered(false)">
    <div class="search--room-header">
      <div class="room-slider-picture">
        <div class="slider-controls">
          <caret-left @click="slidePrev" v-if="slideablePrev"/>
          <caret-right @click="slideNext" v-if="slideableNext"/>
        </div>
        <div class="slider-pictures">
          <div class="inner-slider"
               v-for="(item, index) in room.pictures"
               :class="{active: currentIndex === index, disabled: !room.has_priceplans}"
               :key="item.absolute_path + '__ ' +index"
               :index="index"
               :style="{backgroundImage: `url('${item.absolute_path}?h=600&crop-to-fit')`}"></div>
          <div class="booked-message" v-if="!room.has_priceplans">
            {{$t('v2.search.room_cart')}}
          </div>
        </div>
        <div class="room-like--icon" v-if="room.is_favorite">
          <heart-svg @click="removeFavorite" :colored="true" :filled="true"/>
        </div>
        <div class="room-like--icon" v-else>
          <heart-svg @click="addFavorite" :colored="false" :filled="false"/>
        </div>
      </div>

    </div>
    <div class="equipment-bar" :style="{backgroundColor: '#' + room.color}">
      <img :src="item.icon" :alt="item.text.name" v-for="(item, index) in room.equipments" :key="item.icon"
           :index="index"/>
    </div>
    <div class="room-bloc--content">
      <div style="display: flex; flex-wrap: wrap">
        <router-link tag="a" :to="{name: 'roomDetail', params: {id: room.id}}" class="
        room-name primary-hover">
          {{ room.text.short_name }}
        </router-link>
        <div class="room-label">{{ room.label ? ( room.label.short == 'Luxe' ? '- Suite Luxe ': '') : '' }}</div>
      </div>
      <div class="room-group">{{ room.room_group.text.name }}</div>
      <div class="room-number">
        <router-link tag="a" :to="{name: 'roomDetail', params: {id: room.id}}" class="white-btn">
          {{ $t('roomHighlighted.discoverButton') }}
        </router-link>
      </div>
    </div>
    <div class="price-group">
      <div class="price-item" v-for="(priceplan, index) in priceplans" :index="index" :key="priceplan.from.id"
           :item="priceplan">
        <div class="left-side" v-if="priceplan.from.text.left_label"
             :style="`background: #${priceplan.from.text.color}`">
          <span>{{ priceplan.from.text.left_label }}</span>
        </div>
        <div class="offer">
          <h6>{{ priceplan.from.text.title }} <strong v-if="priceplan.from.text.sub_title">-
            {{ priceplan.from.text.sub_title }}</strong></h6>
          <p>{{ priceplan.from.text.description }}</p>
          <template v-if="priceplan.altPrice && (priceplan.totalPrice - priceplan.touristTax) < (priceplan.altPrice.totalPrice - priceplan.altPrice.touristTax)">
            <span class="value-price stroke">
              {{ (priceplan.altPrice.totalPrice + priceplan.altPrice.extraAdditionalPrice - priceplan.altPrice.touristTax) | decimalPrice | rounded }} €
            </span>
            <span class="alt-price">
              {{ (priceplan.totalPrice + priceplan.extraAdditionalPrice - priceplan.touristTax) | decimalPrice | rounded }} €
            </span>
          </template>
          <template v-else>
            <span class="value-price">
              {{ (priceplan.totalPrice + priceplan.extraAdditionalPrice - priceplan.touristTax) | decimalPrice | rounded }} €
            </span>
          </template>

        </div>
        <div class="choose--wrapper">
          <a class="choose std-btn card-button card-button-colored"
             @click="gotoStep3(priceplan.from.id, room.id)">{{ $t('step2.page.btn.book') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeartSvg from "../../../components/svg/heart-svg";
import CaretRight from "../../../components/svg/caret-right";
import CaretLeft from "../../../components/svg/caret-left";
import moment from "moment";
import {requireAuth} from "../../../router/guards/require-auth.guard";
import {mapState} from "vuex";


export default {
  name: "search-result-room",
  components: {CaretLeft, CaretRight, HeartSvg},
  props: {
    room: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      watchLogin: null
    }
  },
  computed: {
    ...mapState({
      selected: s => s.search.selected
    }),
    slideableNext() {
      return true;
    },
    slideablePrev() {
      return true;
    },
    priceplans() {
      return this.room.computedPrices
    },
    number() {
      return this.room.area
    }
  },
  methods: {
    setHovered(v) {
      if (v) return this.$store.commit('search/SET_HOVERED', this.room.id);
      return this.$store.commit('search/SET_HOVERED', null);
    },
    async gotoStep3(priceId, roomId) {
      this.$emit('loading', true);
      const bookingId = await this.$store.dispatch('shoppingCart/booking/add', {
        start: moment(this.$store.state.search.search.start).toISOString(true),
        end: moment(this.$store.state.search.search.end).toISOString(true),
        room_id: roomId,
        room_price_id: priceId,
        nb_guests: this.$store.getters["search/nbGuests"],
        price_options: [],
      });
      this.$emit('loading', false);
      await this.$router.push({
        name: 'step3',
        params: {
          shoppingCart: this.$store.state.shoppingCart.uuid,
          shoppingBookingId: bookingId
        }
      });
    },
    async addFavorite() {
      requireAuth(null, null, async (err) => {
        if (err) {
          return;
        }
        await this.$store.dispatch('room/like', this.room.id);
        this.room.is_favorite = true;
      })
    },
    async removeFavorite() {
      requireAuth(null, null, async (err) => {
        if (err) {
          return;
        }
        await this.$store.dispatch('room/dislike', this.room.id);
        this.room.is_favorite = false;
      })
    },
    slideNext() {
      let nextIndex = this.currentIndex + 1;
      this.currentIndex = nextIndex % this.room.pictures.length;
    },
    slidePrev() {
      let nextIndex = this.currentIndex - 1;
      if (nextIndex < 0) nextIndex = this.room.pictures.length - 1;
      this.currentIndex = nextIndex % this.room.pictures.length;
    }
  }
}
</script>

<style scoped>
.room-name {
  color: #222;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/parts/search-result-room.vue